interface NewsSectionProps {
  isDarkMode?: boolean;
}

export default function NewsSection({ isDarkMode = false }: NewsSectionProps) {
  const news = [
    {
      title: '即將舉辦長城好聲音卡啦OK大賽',
      date: '2026-3-14',
      category: '賽事報導',
      excerpt: '長城好聲音卡啦OK大賽籌備中 歡迎會員 親屬 朋友報名',
      image: 'https://public.readdy.ai/ai/img_res/5469f1fda5638c46190fc95e9ef21afd.jpg'
    },
    {
      title: '星期四乒乓球初級訓練班(長城)',
      date: '2026-1-12',
      category: '培訓動態',
      excerpt: '逢星期四舉辦的乒乓球初級訓練班.學習基本功技術..',
      image: 'https://readdy.ai/api/search-image?query=Group%20of%20young%20table%20tennis%20students%20with%20coach%20at%20graduation%20ceremony%2C%20happy%20youth%20athletes%20holding%20certificates%2C%20bright%20training%20facility%2C%20celebration%20atmosphere%2C%20simple%20clean%20background&width=600&height=400&seq=news-002&orientation=landscape'
    },
    {
      title: '逢星期六長城會員內部賽活動',
      date: '2026',
      category: '設施更新',
      excerpt: '逢星期六長城球會會員內部賽活動 粉嶺區體育館',
      image: 'https://readdy.ai/api/search-image?query=Modern%20table%20tennis%20training%20facility%20interior%20with%20professional%20equipment%2C%20brand%20new%20sports%20venue%20with%20multiple%20tables%2C%20bright%20spacious%20environment%2C%20clean%20contemporary%20design%2C%20simple%20background&width=600&height=400&seq=news-003&orientation=landscape'
    },
    {
      title: '內地交流活動計劃',
      date: '2026',
      category: '交流活動',
      excerpt: '促進兩地乒乓球交流 聯繫各地球會多交流接觸',
      image: 'https://readdy.ai/api/search-image?query=International%20table%20tennis%20cultural%20exchange%20event%20with%20diverse%20participants%2C%20multicultural%20sports%20gathering%2C%20friendly%20competition%20atmosphere%2C%20modern%20venue%2C%20simple%20clean%20background&width=600&height=400&seq=news-004&orientation=landscape'
    },
    {
      title: '不定期舉行各大球會主持人交流會',
      date: '2026',
      category: '協會動態',
      excerpt: '不定期聯絡各大球會主持人 舉辦交流會活動',
      image: 'https://readdy.ai/api/search-image?query=Professional%20association%20meeting%20with%20members%20in%20conference%20room%2C%20formal%20business%20gathering%2C%20modern%20meeting%20space%2C%20organized%20event%20setting%2C%20simple%20clean%20background&width=600&height=400&seq=news-005&orientation=landscape'
    },
    {
      title: '社區推廣活動深受歡迎',
      date: '2026',
      category: '社區活動',
      excerpt: '社區推廣歡迎各大球會齊參加聯會',
      image: 'https://readdy.ai/api/search-image?query=Community%20table%20tennis%20promotion%20event%20with%20families%20and%20children%2C%20outdoor%20sports%20activity%2C%20friendly%20neighborhood%20gathering%2C%20cheerful%20atmosphere%2C%20simple%20clean%20background&width=600&height=400&seq=news-006&orientation=landscape'
    }
  ];

  return (
    <section id="news" className={`py-24 ${isDarkMode ? 'bg-gray-900' : 'bg-gradient-to-b from-white to-gray-50'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className={`text-5xl md:text-6xl font-black mb-6 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
            最新消息
          </h2>
          <div className="w-24 h-1.5 bg-emerald-600 mx-auto mb-6"></div>
          <p className={`text-xl max-w-3xl mx-auto ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
            掌握最新動態
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {news.map((item, index) => (
            <article
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 border border-gray-100"
            >
              <div className="relative h-56 w-full overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 left-4">
                  <span className="px-4 py-2 bg-emerald-600 text-white text-sm font-bold rounded-full shadow-lg">
                    {item.category}
                  </span>
                </div>
              </div>

              <div className="p-6">
                <div className="flex items-center text-gray-500 text-sm mb-3">
                  <div className="w-4 h-4 flex items-center justify-center mr-2">
                    <i className="ri-calendar-line"></i>
                  </div>
                  <time>{item.date}</time>
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2">
                  {item.title}
                </h3>

                <p className="text-gray-600 mb-4 line-clamp-3 leading-relaxed">
                  {item.excerpt}
                </p>

                <a
                  href="#news"
                  className="inline-flex items-center text-emerald-600 hover:text-emerald-700 font-bold transition-colors cursor-pointer"
                >
                  閱讀更多
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="#news"
            className="inline-block px-10 py-4 bg-gray-900 hover:bg-gray-800 text-white text-lg font-bold rounded-full transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            查看所有消息
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
